export const permissionsDeveloper = ["developer"];
